module.exports = __webpack_public_path__ + "img/beauty.e4e9c376.png";